var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("help-hub-breadcrumb", {
        key: _vm.componentKey,
        staticClass: "guided-help-breadcrumb",
        attrs: { "is-self-service": false, title: _vm.pageTitle }
      }),
      _vm._v(" "),
      _c("help-hub-guided-help", {
        key: _vm.componentKey,
        attrs: {
          title: _vm.pageTitle,
          "user-id": _vm.loggedUser,
          "current-user-access-token": _vm.token
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0186cf5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0186cf5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guided-help/GuidedHelpPage.vue
// module id = null
// module chunks = 